var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_462_453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5C15.9946 7.5 16.9484 7.10491 17.6517 6.40165C18.3549 5.69839 18.75 4.74456 18.75 3.75C18.75 2.75544 18.3549 1.80161 17.6517 1.09835C16.9484 0.395088 15.9946 0 15 0C14.0054 0 13.0516 0.395088 12.3483 1.09835C11.6451 1.80161 11.25 2.75544 11.25 3.75C11.25 4.74456 11.6451 5.69839 12.3483 6.40165C13.0516 7.10491 14.0054 7.5 15 7.5ZM9.41406 19.3125C10.3828 18.9453 10.875 17.8672 10.5078 16.8984C10.1406 15.9297 9.0625 15.4375 8.09375 15.8047C3.36719 17.5859 0 22.1484 0 27.5C0 34.4063 5.59375 40 12.5 40C17.2813 40 21.4297 37.3203 23.5313 33.3828C24.0156 32.4687 23.6719 31.3359 22.7578 30.8437C21.8437 30.3516 20.7109 30.7031 20.2187 31.6172C18.75 34.375 15.8437 36.25 12.5 36.25C7.66406 36.25 3.75 32.3359 3.75 27.5C3.75 23.7578 6.10156 20.5625 9.41406 19.3125ZM20.2969 13.75L20.1484 12.9922C19.7969 11.25 18.2734 10 16.4922 10C14.1406 10 12.375 12.1484 12.8359 14.4531L14.6406 23.4766C15.1094 25.8125 17.1562 27.4922 19.5469 27.4922H27.3984C27.9219 27.4922 28.3828 27.8125 28.5703 28.3047L31.4062 35.875C31.875 37.1328 33.2656 37.7969 34.5391 37.3672L38.2891 36.1172C39.6016 35.6797 40.3047 34.2656 39.8672 32.9531C39.4297 31.6406 38.0156 30.9375 36.7031 31.375L35.2422 31.8594L33.25 26.5469C32.3359 24.1094 30 22.4922 27.3984 22.4922H22.0469L21.2969 18.7422H26.25C27.6328 18.7422 28.75 17.625 28.75 16.2422C28.75 14.8594 27.6328 13.7422 26.25 13.7422H20.2969V13.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.c0cf41d6a1be49576ca555971ef8a31c.svg";
export { ForwardRef as ReactComponent };